// extracted by mini-css-extract-plugin
module.exports = {"container":"AddBotForm_container__2WGRj"};